// Material Kit 2 React components
import MKTypography from 'components/MKTypography';

// Images
import csdd_logo from 'assets/csdd_images/csdd-logo.png';

const date = new Date().getFullYear();

export default {
  brand: {
    name: 'Chamber of Suppliers Development and Diversity-Africa',
    image: csdd_logo,
    route: '/',
  },
  menus: [
    {
      name: 'quick links',
      items: [
        { name: 'about us', route: '/about-us' },
        {
          name: 'our partners',
          route: '/partners',
        },
        {
          name: 'news',
          route: '/news',
        },
        {
          name: 'events and gallery',
          route: '/events',
        },
      ],
    },
    // {
    //   name: 'legal',
    //   items: [
    //     { name: 'privacy policy', route: '/' },
    //     {
    //       name: 'terms & conditions',
    //       route: '/',
    //     },
    //     {
    //       name: 'disclaimer',
    //       route: '/',
    //     },
    //   ],
    // },
    {
      name: 'help & support',
      items: [
        { name: 'contact us', route: '/contact-us' },
        {
          name: 'become a member',
          route: '/contact-us',
        },
        {
          name: '',
          route: '#',
        },
      ],
    },
  ],
  copyright: (
    <MKTypography color='light' variant='button'>
      All rights reserved. Copyright &copy; {date} CSDD-Africa
    </MKTypography>
  ),
};
